import { Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Output, EventEmitter, Input } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
@Component({
  selector: 'app-stage1-view-grade',
  templateUrl: './stage1-view-grade.component.html',
  styleUrls: ['./stage1-view-grade.component.css'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
})
export class Stage1ViewGradeComponent implements OnInit {
  @Input() selectedGradeId: any;
  @Input() selectedGradeName: any;
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCLose: EventEmitter<any> = new EventEmitter<any>();
  customGrade: any;
  grades: any;
  showDropdown = false;
  updatedGradeId: any;
  gradeControl = new FormControl('');
  constructor(private projectsService: ProjectsService) {}
  ngOnInit() {
    this.getProjectGrades();
    this.updatedGradeId = this.selectedGradeName;
    if (this.selectedGradeName) {
      this.gradeControl.setValue(this.selectedGradeName);
    }
  }

  onSelectionChange(grade: { id: number; name: string }) {
    this.updatedGradeId = grade?.id;
    this.selectedGradeName = grade?.name;
    this.gradeControl.setValue(grade?.name);
    this.showDropdown = false;
  }

  onFocus() {
    this.showDropdown = true;
  }

  onBlur() {
    setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }

  getProjectGrades() {
    this.projectsService.getGrades().subscribe({
      next: (response: any) => {
        if (response.meta.success) {
          const apiGrades = response.data.map((grade: any) => ({
            id: grade.id,
            name: grade.name,
          }));

          this.grades = [...apiGrades, { id: 4, name: 'Custom' }];
        }
      },
      error: (error: any) => {
        console.error('Error fetching the project types:', error);
      },
    });
  }
  save() {
    this.onSave.emit(this.updatedGradeId);
  }

  cancel() {
    this.onCLose.emit();
  }
}
